// React
import React from 'react'
// External libs
import classNames from 'classnames'
// Material UI
import { IconButton } from '@material-ui/core'
import { Edit } from '@material-ui/icons'
// Styles
import useStyles from './CustomEditButton.styles'

const CustomEditButton = ({ classes, disabled, onClick }) => {
  const componentClasses = useStyles({ disabled })
  return (
    <IconButton
      aria-label='Edit'
      className={classNames(componentClasses.button, classes.button)}
      disabled={disabled}
      onClick={onClick}
    >
      <Edit className={classNames(componentClasses.icon, classes.icon)} />
    </IconButton>
  )
}

CustomEditButton.defaultProps = {
  classes: {},
}

export default CustomEditButton
